import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { useGfsAssessmentDeleteMutation } from "@/services/backend/gfs/assessment/api";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { toast } from "sonner";

export function DeleteAssessmentDialog({
  assessmentId,
  disabled = false,
}: {
  assessmentId: string;
  disabled?: boolean;
}) {
  const [deleteAssessment, { error, isLoading, isSuccess, reset }] =
    useGfsAssessmentDeleteMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    toast.success(t("Bestandsaufnahme gelöscht"));
    navigate("..");
    reset();
  }, [isSuccess, navigate, reset]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" disabled={disabled}>
          <Trash2 className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Bestandsaufnahme wirklich löschen?")}</DialogTitle>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={() => {
              if (!isLoading) {
                deleteAssessment({ id: assessmentId });
              }
            }}
          >
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
